import { makeStyles } from "@fluentui/react-components";
import * as React from "react";

export interface ErrorScreenProps {
  title: string;
  message: string;
  type: "warning" | "error";
}

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    margin: "auto",
    height: "100vh",
    flexDirection: "column",
    gap: "1rem",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "90%",
  },
  message: {
    textAlign: "center",
  },
  title: {
    fontSize: "1.5rem",
  },
  report: {
    color: "#a5a5a5",
    fontSize: "0.8rem",
    textAlign: "center",
  },
});

const ErrorScreen: React.FC<ErrorScreenProps> = (props: ErrorScreenProps) => {
  const styles = useStyles();
  return (
    <div className={styles.wrapper}>
      <span
        className="material-icons"
        style={{
          fontSize: "3rem",
        }}
      >
        {props.type === "error" ? "error" : "warning"}
      </span>
      <strong className={styles.title}>{props.title}</strong>
      <span className={styles.message}>{props.message}</span>
      <hr style={{ width: "150px", maxWidth: "90%" }} />
      <div className={styles.report}>
        <a href="mailto:supportteam@silvernova.ai" style={{ color: "#a5a5a5" }}>
          Fehler melden? Hier klicken.
        </a>
      </div>
    </div>
  );
};

export default ErrorScreen;
